/* eslint-disable prefer-destructuring, no-underscore-dangle */
import React from 'react';
import PropTypes from 'prop-types';
import { DEVICE } from '@/constants';
import { OS } from '@/utils/detectDevice';
import { thinkOverSounds } from '@/utils/sounds';
import './style.less';

class PickOutTxt extends React.Component {
  static propTypes = {
    finished: PropTypes.func,
    exercisesData: PropTypes.object,
    url: PropTypes.string,
    audioStop: PropTypes.func,
    audioPlay: PropTypes.func,
    soundsUrl: PropTypes.string,
  };

  constructor() {
    super();
    this.state = {
      picOutData: null,
      audio: '',
      right: false,
      playing: false,
    };
  }

  componentDidMount() {
    this.init();
    window.addEventListener('resize', this.changeHeight);
  }

  componentWillReceiveProps(nextProps) {
    nextProps.url !== this.props.url && this.init();
  }

  componentWillUnmount() {
    window.addEventListener('resize', this.changeHeight);
  }

  init = () => {
    const { exercisesData, url } = this.props;
    const answer = exercisesData.questions[0].question[0].answer;
    const Data = [];
    answer.forEach((item) => {
      Data.push({
        txt: item._attr.text._value,
        val: item._attr.score._value,
        class: '',
      });
    });
    this.setState({
      picOutData: Data,
      audio: `${url}QAA/${exercisesData.questions[0].question[0]._attr.audio._value}.ogg`,
    }, () => {
      this.changeHeight();
    });
  }

  changeHeight = () => {
    document.querySelectorAll('.option-li').forEach((item) => {
      const style = window.getComputedStyle(item);
      const optionLi = item;
      const lineHeight = parseInt(style.lineHeight.slice(0, -2), 10);
      const maxSize = OS.TYPE === DEVICE.PC ? '30px' : '18px';
      const minSize = OS.TYPE === DEVICE.PC ? '22px' : '14px';
      Math.round(item.clientHeight / lineHeight) >= 2
        ? (optionLi.style.fontSize = minSize)
        : (optionLi.style.fontSize = maxSize);
    });
  }

  handleCheck=(e, i) => {
    const { picOutData } = this.state;
    const { soundsUrl } = this.props;
    e.preventDefault();
    let right = false;
    if (!this.state.right) {
      picOutData.forEach((item, index) => {
        console.log(item);
        picOutData[index].class = '';
      });
      thinkOverSounds.wrong.sort(() => Math.random() - 0.5);
      if (picOutData[i].val === 100) {
        right = true;
        picOutData[i].class = 'right';
        this.props.audioPlay(`${soundsUrl}${thinkOverSounds.allRight}`, { type: 'exercise' });
        this.props.finished();
      } else {
        this.props.audioPlay(`${soundsUrl}${thinkOverSounds.wrong[0]}`, { type: 'exercise' });
        picOutData[i].class = 'wrong';
      }
      OS.TYPE === DEVICE.PC && this.audioEnd();
    }
    this.setState({ picOutData, right });
  }

  handlePlay = () => {
    const { playing, audio } = this.state;
    !playing ? this.props.audioPlay(audio, { type: 'exercise' }) : this.props.audioStop();
  }

  audioPlay = () => this.setState({ playing: true });

  audioEnd = () => this.setState({ playing: false });

  render() {
    const { picOutData, playing, right } = this.state;
    return (
      <div className="pick-out-txt-container">
        <ul>
          {
            picOutData && picOutData.map((item, index) => (
              <li
                key={`li${index + 1}`}
                className={`option-li ${item.class}`}
                data-val={item.val}
                onClick={(e) => { !right && this.handleCheck(e, index); }}
              >
                {item.txt}
              </li>
            ))
          }
        </ul>
        <div className={`pick-out-play${playing ? ' playing' : ''}`} onClick={this.handlePlay} />
      </div>
    );
  }
}

export default PickOutTxt;
